module.exports = __webpack_public_path__ + "media/images/icons/ic-return-call-a1602438de8efcbeb055e4b4657a75a7.svg";